<script>
    import { isMobile } from "@/utils";
    import StoreShop from "@/components/StoreShop";
    import MobileTabs from "@/components/MobileTabs.vue";

    export default {
        name: "StoreShops",
        components: { MobileTabs, StoreShop },
        props: {
            sliderOptions: Object,
            slidesCount: Object,
            icon: String,
        },
        data() {
            return {
                selectedTabIndex: 0,
                newCities: {
                    "#msk": {
                        index: 0,
                        code: "msk",
                        name: "Москва",
                    },
                    "#spb": {
                        index: 1,
                        code: "spb",
                        name: "Санкт-Петербург",
                    },
                    "#ekb": {
                        index: 2,
                        code: "ekb",
                        name: "Екатеринбург",
                    },
                    "#krd": {
                        index: 3,
                        code: "krd",
                        name: "Краснодар",
                    },
                },
            };
        },
        computed: {
            cityName() {
                return Object.values(this.newCities).find(
                    (city) => city.index === this.selectedTabIndex
                ).name;
            },
            tabOffsetCompute() {
                return 100 * this.selectedTabIndex + "%";
            },
            shops() {
                return [
                    {
                        type: "msk",
                        iframe: '<iframe src="https://yandex.ru/map-widget/v1/?um=constructor%3A41a367aae849d125ee93d28a232574e4bf694adc968f2e2a9cf6530b2ed43725&amp;source=constructor" width="600" height="480" frameborder="0"></iframe>',
                        address: "Бутырский Вал, 32",
                        phone: "+7 495 646-10-96",
                        routes: [
                            { title: "Маршрут от Новослободской", url: "/5/" },
                            { title: "Маршрут от Белорусской", url: "/4/" },
                        ],
                        slides: this.slidesCount.msk,
                    },
                    {
                        type: "spb",
                        iframe: '<iframe src="https://yandex.ru/map-widget/v1/?um=constructor%3Ac6f9b787eeebe5ed6ea9c25a7ccad2e52657b10554778a34a65a58403f0a825d&amp;source=constructor" width="600" height="480" frameborder="0"></iframe>',
                        address: "Лиговский проспект, 3/9",
                        phone: "+7 812 407-35-98",
                        routes: [{ title: "Маршрут от Площади Восстания", url: "/7/" }],
                        slides: this.slidesCount.spb,
                    },
                    {
                        type: "ekb",
                        iframe: '<iframe src="https://yandex.ru/map-widget/v1/?um=constructor%3Addb23712cb2e365cdb6341786c0719c5a8602318dd4692abae978a44d43ac5e9&amp;source=constructor" width="600" height="480" frameborder="0"></iframe>',
                        address: "ул. Горького, 33А",
                        phone: "+7 343 363-33-16",
                        routes: [{ title: "Маршрут от м. Площадь 1905 года", url: "/11/" }],
                        slides: this.slidesCount.ekb,
                    },
                    {
                        type: "krd",
                        iframe: '<iframe src="https://yandex.ru/map-widget/v1/?um=constructor%3Ae7fedec2b8b4574d9634058e92244cb7a83f0d94e302e8f4cc6267a260b6ded7&amp;source=constructor" width="600" height="480" frameborder="0"></iframe>',
                        address: "ул. Леваневского, 187",
                        phone: "+7 861 21-12-861",
                        // routes: [{ title: "Маршрут от м. Площадь 1905 года", url: "/12/" }],
                        slides: this.slidesCount.krd,
                    },
                ];
            },
        },
        mounted() {
            if (this.$route.hash) {
                this.selectedTabIndex = this.newCities[this.$route.hash]?.index || 0;
            }
        },
        methods: {
            onChangeTab(index) {
                this.selectedTabIndex = index;
                if (!isMobile(992)) {
                    const hash = Object.values(this.newCities)[index].code;
                    this.$router.push({ hash });
                }
            },
        },
    };
</script>

<template>
    <div class="store-shops js-store-shops">
        <div class="store-shops__tabs">
            <div class="store-shops__controls">
                <span
                    class="store-shops__controls-progress"
                    :style="{ transform: `translateX(${tabOffsetCompute})` }"
                ></span>
                <button
                    v-for="city in Object.values(newCities)"
                    class="store-shops__trigger outline"
                    :class="{ selected: selectedTabIndex === city.index }"
                    :key="city.index"
                    @click="onChangeTab(city.index)"
                >
                    {{ city.name }}
                </button>
            </div>

            <div class="store-shops__mobile desktop-hidden">
                <mobile-tabs :max-length="4" @on-change="onChangeTab">
                    <div class="store-shops__city">
                        {{ cityName }}
                    </div>
                </mobile-tabs>
            </div>

            <div class="store-shops__content">
                <div class="store-shops__tab">
                    <store-shop
                        :id="selectedTabIndex"
                        :shop="shops[selectedTabIndex]"
                        :slider-options="sliderOptions"
                        :icon="icon"
                    ></store-shop>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .store-shops {
        padding-top: 16px;
        @include bp($bp-desktop-sm) {
            padding-top: 32px;
        }
    }

    .store-shops__tabs {
        margin-bottom: 20px;
        border: var(--new-store-content-border);
        border-color: var(--new-store-content-border-color);
        border-radius: var(--new-store-content-radius);
        box-shadow: var(--new-store-content-shadow);
        @include bp($bp-desktop-sm) {
            border: none;
            box-shadow: none;
        }
    }

    .store-shops__controls {
        display: none;
        @include bp($bp-desktop-sm) {
            position: relative;
            display: flex;
            margin-bottom: 16px;
            background-color: var(--new-store-button-fill);
            border-radius: var(--new-store-button-radius);
            overflow: hidden;
        }
    }

    .store-shops__controls-progress {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        width: 25%;
        background: var(--new-store-button-fill--selected);
        border-radius: inherit;
        pointer-events: none;
        transition: transform 0.2s ease-in;
    }

    .store-shops__mobile {
        padding: 16px 8px 0;
    }

    .store-shops__city {
        color: var(--new-store-city-title-color--mobile);
        font-family: var(--new-store-button-font);
        font-size: 22px;
        font-weight: 500;
        line-height: 30px;
        text-align: center;
        text-transform: var(--new-store-button-case);
    }

    .store-shops__trigger {
        @include bp($bp-desktop-sm) {
            position: relative;
            z-index: 2;
            flex-basis: 25%;
            max-width: 25%;
            padding: 30px 15px 28px;
            font-family: var(--new-store-button-font);
            font-size: 24px;
            font-weight: 500;
            line-height: 32px;
            text-transform: var(--new-store-button-case);
            border-radius: var(--new-store-button-radius);
            transition: color 0.2s ease-in;
            &:hover:not(.selected) {
                color: var(--new-store-button-color--hover);
            }
            &.selected {
                color: var(--new-store-button-color--active);
            }
        }
    }

    .store-shops__content {
        padding: 16px 12px 12px;
        border: none;
        border-radius: var(--new-store-content-radius);
        box-shadow: none;
        @include bp($bp-desktop-sm) {
            padding: 40px 40px 72px;
            border: var(--new-store-content-border);
            box-shadow: var(--new-store-content-shadow);
        }
    }
</style>
